import { jsxs, jsx } from 'react/jsx-runtime';
import { i18n } from '../../../utils/i18n.js';
import { Popover, Tooltip } from '@tecsinapse/cortex-react';
import { clsx } from 'clsx';
import { useState } from 'react';
import { TbWorld } from 'react-icons/tb';
import { Icon } from '../components/icon.js';

const LanguageList = (props) => {
  const {
    locales,
    idioma,
    onLanguageChange
  } = props;
  const currentLocale = idioma.id || idioma.value || idioma;
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsxs(Popover.Root, { trigger: "click", controlled: true, isOpen: open, setIsOpen: setOpen, children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: i18n._(
      /*i18n*/
      {
        id: "frUGhT"
      }
    ), children: /* @__PURE__ */ jsx(TbWorld, { className: "text-secondary-medium hover:cursor-pointer", size: 24 }) }) }),
    /* @__PURE__ */ jsx(Popover.Content, { className: "bg-white", children: locales.map((locale) => /* @__PURE__ */ jsxs("div", { onKeyDown: () => {
      onLanguageChange?.(locale.id);
      setOpen(false);
    }, onClick: () => {
      onLanguageChange?.(locale.id);
      setOpen(false);
    }, className: clsx("flex items-center gap-x-mili hover:bg-secondary-light hover:cursor-pointer px-deca py-mili", currentLocale === locale.id && "bg-secondary-light"), children: [
      /* @__PURE__ */ jsx(Icon, { idLanguage: locale.id }),
      /* @__PURE__ */ jsx("p", { children: locale.description })
    ] }, locale.id)) })
  ] });
};

export { LanguageList };
